import * as XLSX from 'xlsx';

export const headersAreMatching = (excelHeaders, selectedTemplateHeaders) => {
  if (excelHeaders?.length !== selectedTemplateHeaders.length) return false;
  const sortedExcelHeaders = excelHeaders.sort();
  const sortedSelectedTemplateHeaders = selectedTemplateHeaders.sort();

  for (let i = 0; i < sortedExcelHeaders.length; i++) {
    if (sortedExcelHeaders[i] !== sortedSelectedTemplateHeaders[i]) return false;
  }
  return true;
};

export const parseSheetToJson = (sheet, options) => {
  const jsonData = XLSX.utils.sheet_to_json(
    sheet,
    options || {
      defval: '',
    },
  );
  return jsonData;
};

const isValidDate = (date) => {
  return !isNaN(Date.parse(date));
};

export const parseUploadedExcelSheetToJson = (sheet) => {
  const jsonData = parseSheetToJson(sheet, {
    defval: '',
    raw: true,
  });
  if (jsonData.length === 0) return jsonData;
  // Manually format dates because excel sheet saves the date as a date serial number
  jsonData.forEach((row) => {
    for (const key in row) {
      if (row[key] instanceof Date) {
        const date = row[key];
        if (isValidDate(date)) {
          row[key] = date?.toLocaleDateString();
        }
      }
    }
  });
  return jsonData;
};
